import { useQuery } from "react-query";
import { transportationService } from "../../services/transportationService";
import { accountScopedQueryOptions, useAccountQueryContext } from "../useAccountQueryContext";

export const useTransportStudents = (filters, options = {}) => {
  const { tokenValue, accountKey } = useAccountQueryContext();
  return useQuery(
    ["transportation", "students", accountKey, filters],
    () => transportationService.getStudents(tokenValue, filters),
    { ...accountScopedQueryOptions, keepPreviousData: true, enabled: Boolean(tokenValue) && options.enabled !== false, ...options }
  );
};
